
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.7501 2.99951H8.75009C8.55118 2.99952 8.36042 3.07854 8.21977 3.21919C8.07912 3.35984 8.0001 3.5506 8.00009 3.74951V7.49961H4.25C4.05109 7.49962 3.86033 7.57864 3.71968 7.71929C3.57903 7.85994 3.50001 8.0507 3.5 8.24961V20.2496C3.50001 20.4485 3.57903 20.6393 3.71968 20.7799C3.86033 20.9206 4.05109 20.9996 4.25 20.9996H16.25C16.4489 20.9996 16.6397 20.9206 16.7803 20.7799C16.921 20.6393 17 20.4485 17 20.2496V16.4995H20.7501C20.949 16.4995 21.1398 16.4205 21.2804 16.2798C21.4211 16.1392 21.5001 15.9484 21.5001 15.7495V3.74951C21.5001 3.5506 21.4211 3.35984 21.2804 3.21919C21.1398 3.07854 20.949 2.99952 20.7501 2.99951ZM20.0001 14.9995H17V8.24961C17 8.0507 16.921 7.85994 16.7803 7.71929C16.6397 7.57864 16.4489 7.49962 16.25 7.49961H9.50009V4.49951H20.0001V14.9995Z","fill":"currentColor"}})])
          )
        }
      }
    